import { Component, OnInit } from '@angular/core';

import { OverviewService } from './overview.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {

  constructor(public overviewService: OverviewService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/overview/overview.component.ts